/**
 * API 설정 파일
 * 환경 변수를 통해 개발/운영 환경의 API URL을 관리합니다.
 */

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

/**
 * API 엔드포인트 상수
 */
export const API_ENDPOINTS = {
  // 뉴스 관련
  NEWS: '/api/news',
  NEWS_DETAIL: (id: string | number) => `/api/news/${id}`,

  // 제품 관련
  PRODUCTS: '/api/products',
  PRODUCT_DETAIL: (id: string | number) => `/api/products/${id}`,

  // 인증 관련
  AUTH_LOGIN: '/api/auth/login',
  AUTH_LOGOUT: '/api/auth/logout',
} as const;
